export const USE_NO_BREAKDOWNS_ENTRY = "useNoBreakdowns";

export function isDummyField(field: string): boolean {
  return field === USE_NO_BREAKDOWNS_ENTRY;
}
